module.exports = __webpack_public_path__ + "static/media/CIEL-AMC-funnel.b8a766b8.png";